<template>
  <div class="mobile">
    <header>
      <picture class="logo">
        <source srcset="@/assets/logo@2x.png" media="(min-resolution: 2dppx)" />
        <img src="@/assets/logo.png" alt="" />
      </picture>
      <picture class="logo-text">
        <source
          srcset="@/assets/logo-text@2x.png"
          media="(min-resolution: 2dppx)"
        />
        <img src="@/assets/logo-text.png" alt="" />
      </picture>
    </header>
    <main>
      <div class="logo-name">
        <picture>
          <source
            srcset="@/assets/logo-name@2x.png"
            media="(min-resolution: 2dppx)"
          />
          <img src="@/assets/logo-name.png" alt="" />
        </picture>
      </div>
      <div class="sub-text">
        <picture>
          <source
            srcset="@/assets/sub-text@2x.png"
            media="(min-resolution: 2dppx)"
          />
          <img src="@/assets/sub-text.png" alt="" />
        </picture>
      </div>
      <div class="button-group">
        <div class="button" @click="goPage(iosUrl)">
          <picture class="button-img">
            <source
              srcset="@/assets/ios@2x.png"
              media="(min-resolution: 2dppx)"
            />
            <img src="@/assets/ios.png" alt="" />
          </picture>
          <div class="button-content">
            <div>Download on the</div>
            <div class="store-name">App Store</div>
          </div>
        </div>
        <div class="button" @click="goPage(androidUrl)">
          <picture class="button-img">
            <source
              srcset="@/assets/android@2x.png"
              media="(min-resolution: 2dppx)"
            />
            <img src="@/assets/android.png" alt="" />
          </picture>
          <div class="button-content">
            <div>Download on the</div>
            <div class="store-name">Android</div>
          </div>
        </div>
      </div>
    </main>
    <footer>
      <span>无锡风睐科技有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">备案号：xxxxxxx</a>
    </footer>
  </div>
</template>

<script setup>
import { iosUrl, androidUrl } from "../../public/urlConfig";
const goPage = (url) => {
  window.location.href = url;
};
</script>
<style scoped lang="scss">
.mobile {
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-rows: max-content 1fr 120px;
  header {
    display: flex;
    align-items: center;
    margin: 39px 49px 66px;
    .logo {
      & > img {
        width: 60px;
        height: 60px;
      }
    }
    .logo-text {
      margin-left: 11px;
      & > img {
        width: 117px;
        height: 33px;
      }
    }
  }
  main {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .logo-name {
      & img {
        width: 169px;
        height: 118px;
      }
      margin-bottom: 26px;
    }
    .sub-text {
      & img {
        width: 324px;
        height: 33px;
      }
      margin-bottom: 51px;
    }
    .button-group {
      & > div:first-child {
        margin-right: 108px;
      }
      .button {
        &:focus-visible {
          outline: none;
        }
        display: inline-grid;
        grid-template-columns: 40px 1fr;
        column-gap: 11px;
        width: 250px;
        height: 78px;
        background: #ff8dae;
        border-radius: 10px 10px 10px 10px;
        border: 2px solid #ffffff;
        align-content: center;
        padding-left: 13px;
        box-sizing: border-box;
        color: white;
        font-size: 20px;
        .button-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .button-img {
          & > img {
            width: 40px;
            /* height: 38px; */
            object-fit: contain;
          }
        }
        .store-name {
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  }
  footer {
    display: flex;
    align-items: center;
    border-top: 1px solid #ffb2cb;
    font-size: 24px;
    justify-content: center;
    flex-direction: column;

    & > a {
      color: #f35d8d;
      text-decoration: none;
    }
    & > span:first-child {
      /* margin-right: 61px; */
      margin-bottom: 15px;
    }
  }
}
</style>
